export default function initRellax()
{
    const Rellax = require('rellax');
    const selector = '.wp-block-cover.js-parallax .wp-block-cover__image-background';
    const rellax = new Rellax(selector, {
        speed: -6,
        percentage: 0.5,
        zindex: 0,
        center: true,
    });
}
